import withAuthRequired from './withAuthRequired';

export default withAuthRequired;
